import "jquery-validation"; 

// Ensure DelhiZoo namespace exists
const DelhiZoo = window.DelhiZoo || {};

DelhiZoo.subscriber = {
  // Initialize the module
  init: () => {
    DelhiZoo.subscriber.allFormValidation();
  },

  // Handles AJAX submission of the subscriber form
  handleSubscriberSubmission: () => {
    const form = $("#new_subscriber");
      $("#loading-overlay")?.show();
      $.ajax({
        url: form.attr("action"),
        type: "POST",
        data: form.serialize(),
        success: (response) => {
          $("#loading-overlay")?.hide();

          if (response.status === "success") {
            $(".js-subscribe-modal-div")?.addClass("dn");
            $(".js-subscriber-thankyou-div")?.removeClass("dn");
          } else if (response.status === "invalid_captcha") {
            $(".js-captcha-refresh-button a")?.click();
            $(".js-invalid-captcha-message")?.removeClass("dn");
          } else if (response.status === "error") {
            alert("Please try after some time.");
          }
        },
        error: (response) => console.log(response)
      });
    
  },

  // Initialize jQuery validation for subscriber form
  allFormValidation: () => {
    const $form = $("#new_subscriber");

    if ($form.length) {
      $form.validate({
        errorClass: "error_message",
        rules: {
          "subscriber[email]": {
            required: true,
            email: true
          }
        },
        messages: {
          "subscriber[email]": {
            required: "Please enter your email",
            email: "Please enter a valid email"
          }
        },
        submitHandler: (form) => {
          if ($(form).valid?.()) {
            DelhiZoo.subscriber.handleSubscriberSubmission()
          }
        }
      });
    }
  }
};

// Attach to global window object
window.DelhiZoo = DelhiZoo;

// Use turbolinks:load if Rails Turbolinks is active
document.addEventListener("turbolinks:load", () => DelhiZoo.subscriber.init());
